module.exports = __webpack_public_path__ + "static/assets/2749dfc28633849453a41172270f12c6.png";